function Audio() {

  return (

      <audio
        preload="auto"
        id="beep"
        src="https://raw.githubusercontent.com/freeCodeCamp/cdn/master/build/testable-projects-fcc/audio/BeepSound.wav"
      >
        audio component
      </audio>
  );
}

export default Audio;


